<script setup>
import { ref } from 'vue';

const mathFieldElement = ref(null);

const expression = defineModel();

const handleChange = (event) => {
    /**
     * @type {MathfieldElement}
     */
    const target = event.target;
    expression.value = target.getValue();
};

defineOptions({
    name: 'LatexField',
});
</script>

<template>
    <math-field style ref="mathFieldElement" @input="handleChange" class="border-2 border-gray-800 min-h-16 min-w-40">
        {{ expression }}
    </math-field>
</template>
